// extracted by mini-css-extract-plugin
export default {"list":"AuthNav_list__iNgUV","item":"AuthNav_item__n3334","link":"AuthNav_link__SJWB-","login":"AuthNav_login__qcC04","icon":"AuthNav_icon__aPpSa"};